<div class="modal-container">
  <div class="modal">
    <h2 class="modal-heading">
      Select a
      @if (reasons && reasons[0]?.reasonTypeId == ReasonTypeEnum.Drop) {
        <span>Drop </span>
      }
      @if (reasons && reasons[0]?.reasonTypeId == ReasonTypeEnum.Discharge) {
        <span>Discharge </span>
      }
      @if (reasons && reasons[0]?.reasonTypeId == ReasonTypeEnum.Disqualify) {
        <span>Disqualify </span>
      }
      reason
    </h2>
    @if (reasons?.length > 0) {
      <div class="confirmation-message">
        <p>
          By selecting a reason and clicking save, you are confirming your intention to change the status of the candidate
          to
          @if (reasons && reasons[0]?.reasonTypeId == ReasonTypeEnum.Drop) {
            <span>'Dropped' </span>
          }
          @if (reasons && reasons[0]?.reasonTypeId == ReasonTypeEnum.Discharged) {
            <span>'Discharged' </span>
          }
          @if (reasons && reasons[0]?.reasonTypeId == ReasonTypeEnum.Disqualified) {
            <span>'Disqualified' </span>
          }
          with the chosen reason.
        </p>
      </div>
    }

    @if (reasons?.length > 0) {
      <div class="modal-content" [class.options-container]="invalidReason">
        <mat-radio-group class="mat-radio-group" [(ngModel)]="selectedReason" (change)="onRadioChange($event)">
          @for (reason of reasons; track reason) {
            <div class="option-card">
              <mat-radio-button color="primary" [value]="reason">{{reason.description}}</mat-radio-button>
            </div>
          }
        </mat-radio-group>
      </div>
    }
    @if (!reasons) {
      <div class="spinner-container">
        <mat-spinner class="spinner" mode="indeterminate"></mat-spinner>
      </div>
    }
    @if (invalidReason) {
      <div class="validation-message">
        Please select a reason.
      </div>
    }
    <div class="modal-buttons">
      <button class="btn-save" (click)="onSaveClicked()">Save</button>
      <button class="btn-cancel" (click)="onCancelClicked()">Cancel</button>
    </div>
  </div>
</div>
